<template>
    <div class="templateList">
        <div class="tabs">

            <!-- Tab切换 -->
            <div class="tabBox">
                <div :class="[index == thisTab ? 'checkTab' : '', 'tab']" :title="item" @click="tabTemplate(index)"
                    v-for="(item, index) in templateName">{{ item }}</div>
            </div>

            <!-- 个人模板 -->
            <Select class="deviceTypeSelect" v-model="passedDeviceType" v-if="thisTab == 0">
                <Option value="x线">x线</Option>
                <Option value="CT">CT</Option>
                <Option value="MR">MR</Option>
            </Select>


            <!-- 公共模板 -->
            <Select class="deviceTypeSelect" v-model="deviceTypeSelect" @on-change='changeType' v-if="thisTab == 1">
                <Option :value="i.id" v-for="(i, index) in deviceTypeList" :key="index">{{ i.contents }}</Option>
            </Select>

        </div>

        <!-- 加载对应组件
        deviceType是给个人模板传递的
        partsList是给公共模板传递的-->
        <component class="templateBody" :deviceType="passedDeviceType" :partsList='partsList' @checkTemplate="checkTemplate"
            :is="thisTab == 0 ? 'PersonalTemplate':'PublicTemplate'">
        </component>
    </div>
</template>


<script>

import PublicTemplate from './PublicTemplate.vue';
import PersonalTemplate from './PersonalTemplate.vue';

export default {
    components: {
        PublicTemplate,
        PersonalTemplate
    },
    props: ["deviceType"],
    data() {
        return {
            perlist: [],
            parts: [],
            partsList: [],
            passedDeviceType: '',
            deviceTypeSelect: '',
            deviceTypeList: [],
            value: "",
            list: [],
            templateList: [],
            thisTab: 0,
            templateName: ["个人模板", "公共模板"],
            disease: [],
            searchValue: ""
        }
    },
    methods: {

        // 公共模板切换设备类型
        changeType(value) {
            let data = {
                ownerId: value
            }
            this.searchSecond(data)
        },

        // 查询模板第二级
        searchSecond(value) {
            this.$api.data.findTemplateReport(value).then((res) => {
                this.partsList = res.list
            })
        },

        /**
        * 切换模板类型
        */
        tabTemplate(value) {
            this.thisTab = value

        },

        checkTemplate(value) {
            this.$emit('checkTemplate', value)
        },
        searchDisease(value) {
            let data = {
                title: this.searchValue
            }
            this.$api.data.findTemplateReport(data).then((resDia) => {
                this.disease = resDia.list
            })
        },
        _initData() {
            // 这里是查找的公共模板中的第一级分类
            let data = {
                ownerId: 0
            }
            this.$api.data.findTemplateReport(data).then((resDia) => {
                // 找到设备类型列表，如CT、X线、MR等等
                this.deviceTypeList = resDia.list

                // 找到设备类型对应的id
                for (let i in this.deviceTypeList) {
                    if (this.deviceTypeList[i].contents.indexOf(this.passedDeviceType) >= 0) {
                        this.deviceTypeSelect = this.deviceTypeList[i].id

                        // 查找公共模板第二级
                        this.searchSecond({ ownerId: this.deviceTypeSelect })
                        break;
                    }
                }


            });
        }

    },
    watch: {
        "deviceType": {
            handler: function (val, oldval) {

                // 设备类型由写报告页面传过来
                this.passedDeviceType = this.deviceType
                // this.tabTemplate(0)
            }
        }
    },
    mounted() {
        this._initData()
    }
}
</script>

<style lang="scss" scoped>
.templateList {
    width: 100%;
    height: 100%;
    background: white;
    display: flex;
    flex-direction: column;

    .tabs {
        width: 100%;
        padding-bottom: 5px;

        .tabBox {
            width: 50%;
            float: left;
            margin-top: 5px;

            &::after {
                content: "";
                display: block;
                height: 0;
                clear: both;
                visibility: hidden;
            }
        }

        .tab {
            width: 50%;
            font-size: 16px;
            float: left;
            line-height: 30px;
            text-align: center;
            cursor: pointer;
            border-bottom: 1px solid #dddddd;
        }

        .checkTab {
            border-bottom: 2px solid #2d8cf0;
            font-weight: 600;
        }

        .deviceTypeSelect {
            width: 100px;
            float: right;
            margin-top: 5px;
        }

    }

    .templateBody {
        // background: yellow;
        flex: 1;
        overflow-y: scroll;
        overflow-x: hidden;
    }

}
</style>



// WEBPACK FOOTER //
// src/components/WriteHanding/ReportTemplate.vue